<template>
  <div class="gs-copy-row">
    <div v-if="label" class="gs-copy-row__label">{{ label }}</div>
    <div class="gs-copy-row__control">
      <textarea
        v-if="multiline"
        data-field="value"
        class="gs-copy-row__input gs-copy-row__input--multiline"
        :value="value"
        readonly
      ></textarea>
      <input
        v-else
        type="text"
        data-field="value"
        class="gs-copy-row__input"
        :value="value"
        readonly
      />
      <gs-button
        v-if="openable"
        variant="ghost"
        size="sm"
        data-action="open"
        @click="$emit('open')"
      >
        <gs-icon name="external-link" size="16" />
        Open
      </gs-button>
      <gs-button
        :variant="primary ? 'primary' : 'outline'"
        size="sm"
        data-action="copy"
        v-clipboard:copy="value"
        v-clipboard:success="onCopied"
        v-clipboard:error="onCopyError"
      >
        <gs-icon :name="copied ? 'check' : 'copy'" size="16" />
        {{ copied ? 'Copied' : copyLabel() }}
      </gs-button>
    </div>
    <p v-if="hint" class="gs-copy-row__hint">{{ hint }}</p>
  </div>
</template>

<script>
export default {
  name: 'CopyRow',
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    hint: {
      type: String,
      default: '',
    },
    multiline: {
      type: Boolean,
      default: false,
    },
    primary: {
      type: Boolean,
      default: false,
    },
    openable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      copied: false,
      copiedTimer: null,
    };
  },
  beforeDestroy() {
    if (this.copiedTimer) {
      clearTimeout(this.copiedTimer);
    }
  },
  methods: {
    // `$t` is a global vue-i18n mixin in every real app context, but this is
    // a low-level shared component whose own spec mounts it without that
    // plugin — falling back to the literal keeps that mount working instead
    // of throwing `this.$t is not a function`.
    copyLabel() {
      return typeof this.$t === 'function' ? this.$t('frontend_video_copy') : 'Copy';
    },
    onCopied() {
      this.copied = true;
      this.$emit('copied');
      if (this.copiedTimer) {
        clearTimeout(this.copiedTimer);
      }
      this.copiedTimer = setTimeout(() => {
        this.copied = false;
      }, 2000);
    },
    onCopyError() {
      this.$emit('copy-failed');
    },
  },
};
</script>

<style scoped>
.gs-copy-row {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.gs-copy-row__label {
  color: var(--gs-foreground);
  font-size: 14px;
  font-weight: 700;
}

.gs-copy-row__control {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: flex-start;
}

.gs-copy-row__input {
  flex: 1 1 260px;
  min-width: 0;
  min-height: 40px;
  padding: 0 12px;
  color: var(--gs-foreground);
  background: var(--gs-surface-subtle);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-sm);
  font-size: 13px;
}

.gs-copy-row__input--multiline {
  min-height: 110px;
  padding: 10px 12px;
  font-family: var(--gs-font-mono);
  font-size: 12px;
  line-height: 1.6;
  resize: vertical;
}

.gs-copy-row__hint {
  margin: 0;
  color: var(--gs-muted-foreground);
  font-size: 12px;
  font-weight: 600;
}
</style>
